import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { bodySx, buttonSx, DANGER, INK, outlinedButtonSx } from './styles';

// confirm: { title, message, confirmLabel, onConfirm } or null when closed.
export default function ConfirmDialog({ confirm, onClose }) {
  return (
    <Dialog
      open={!!confirm}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: '14px', p: 0.5 } }}
    >
      <DialogTitle sx={{ fontFamily: 'Rubik', fontWeight: 700, fontSize: '18px', color: INK, pb: 1 }}>{confirm?.title}</DialogTitle>
      <DialogContent>
        <Typography sx={{ ...bodySx, fontSize: '14px', color: '#3d4a45' }}>{confirm?.message}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button variant="outlined" onClick={onClose} sx={outlinedButtonSx}>Cancel</Button>
        <Button
          variant="contained"
          disableElevation
          onClick={() => {
            const action = confirm?.onConfirm;
            onClose();
            action && action();
          }}
          sx={{ ...buttonSx, backgroundColor: DANGER, color: '#fff', '&:hover': { backgroundColor: '#a91f1f', boxShadow: 'none' } }}
        >
          {confirm?.confirmLabel || 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
